export default __webpack_public_path__ + "static/media/icon-clipboard-list-check-filled.eac6471a.svg";